import { Formik } from "formik";
import Loader from "../../components/loader";
import { useLocation, useNavigate } from "react-router-dom";
import AuthLayout from "../../layout/AuthLayout";
import { signUpSchema } from "../../utils/schema";
import { webPaths } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import useCountry from "../../components/hooks/useCountry";
import { authSignUp } from "../../redux/actions/authAction";
import ErrorMessage from "../../components/forms/ErrorMessage";
import { buildAuthModalState } from "../../routes/authModal";

const Signup = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
    const countryData = useCountry();
  const { isLoading } = useSelector((state) => state.authReducer);
  const initialValues = {
    identifier: "",
    full_name: "",
    acceptTerms: false,
  };


  const handleSignUp = async (values) => {
    const callback = (response) => {
      if (response.success)
        navigate(webPaths?.OtpVarification, {
          state: buildAuthModalState(location, {
            redirectFrom: webPaths?.Signup,
            identifier: values?.identifier,
          }),
        });
    };
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.identifier);

    const payload = {
      full_name: values.full_name,
      country: countryData?.country_name || "India",
      ...(isEmail
        ? { email: values.identifier }
        : { phone_no: `${countryData?.country_calling_code}${values.identifier}` }),
    };

    dispatch(
      authSignUp({
        payload,
        callback,
      }),
    );
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <AuthLayout>
      <div class="col-lg-12 mx-auto  login-popup__left ct_custom_scroll">
        <div>
          <div class="login-popup__brand mb-3">
            <img
              onClick={() => {
                navigate(webPaths?.WebHome);
              }}
              style={{ cursor: "pointer" }}
              src="/assets/img/logo_black.png"
              class="main-logo"
              alt="SecurPoint"
            />
          </div>

          <h5 class="login-popup__title mb-2 ct_fs_28 text-center">Welcome!</h5>
          <p class="ct_fs_15 ct_fw_500 text-center opacity-50 mb-0">
            Please enter your email to verify your account
          </p>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={signUpSchema}
          onSubmit={(values, actions) => {
            handleSignUp(values);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <div class="login-popup__roles">
                <div class="">
                  <label class="mt-3 ct_fs_16 ct_fw_400 mb-2">
                    {" "}
                    Full Name{" "}
                  </label>
                  <input
                    type="text"
                    class="form-control ct_input ct_login_input"
                    placeholder="Enter full name"
                    id="full_name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.full_name}
                  />
                  <ErrorMessage
                    errors={errors}
                    touched={touched}
                    fieldName="full_name"
                  />
                </div>
                <div class="">
                  <label class="mt-3 ct_fs_16 ct_fw_400 mb-2">
                    Email / Phone
                  </label>
                  <input
                    type="text"
                    class="form-control ct_input ct_login_input"
                    placeholder="Enter email / phone"
                    id="identifier"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.identifier}
                  />
                  <ErrorMessage
                    errors={errors}
                    touched={touched}
                    fieldName="identifier"
                  />
                </div>

                <div class="form-check ct_custom_check mt-3 d-flex gap-2 align-items-center">
                  <input
                    class="form-check-input ct_input "
                    type="checkbox"
                    value=""
                    id="acceptTerms"
                    checked={values.acceptTerms}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <label for="flexCheckDefault" class="ct_fs_12 ct_fw_400">
                    By creating an account, you agree to our
                  <span
                      class="ct_green_text ct_cursor_pointer"
                      onClick={() => {
                        navigate(webPaths?.TermsofService);
                      }}
                    >
                      {" "}
                      Terms of Service.
                    </span>
                  </label>
                </div>
                <ErrorMessage
                  errors={errors}
                  touched={touched}
                  fieldName="acceptTerms"
                />
              </div>

              <a
                onClick={(e) => {
                  e.preventDefault();
                  // navigate(webPaths?.OtpVarification);
                  handleSubmit();
                }}
                class="btn mt-4 ct_green_bnt ct_white_nowrap w-100"
              >
                Send OTP
              </a>

              <p class="ct_fs_15 ct_fw_500 mt-3 text-center mb-0">
                Already have an account?
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(webPaths?.Login, {
                      state: buildAuthModalState(location),
                    });
                  }}
                  class="ct_fs_15 ct_fw_600 ct_green_text ct_cursor_pointer"
                >
                  {" "}
                  Sign in
                </a>
              </p>
            </form>
          )}
        </Formik>
      </div>
    </AuthLayout>
  );
};

export default Signup;
